import { useRecoilValue } from 'recoil';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {
  Stack,
  Button,
  Typography,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import Page from '../components/Page';
import { userAtom } from '../atoms/user';
import RequestsGrid from 'src/components/RequestsGrid/RequestsGrid';
import { getAllRequests, getMyRequests } from 'src/services/request.service';
import AdminExportButton from 'src/components/AdminExportButton';
import { useState } from 'react';
import { approveRequests, resolveRequest } from '../services/admin.service';

const ConfirmApproveDialog = ({ open, onClose, onApprove }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Approve</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to approve selected request(s)?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onApprove} color="primary">
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default function Requests({ mine }) {
  const user = useRecoilValue(userAtom);
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate();
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  return (
    <Page
      title={`${mine ? 'My' : 'All'} Requests | Incorta`}
      style={{ paddingInline: match ? '16px' : '0px' }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          {mine ? 'My' : 'All'} Requests
        </Typography>

        {mine && (
          <Button
            variant="contained"
            component={RouterLink}
            to="/dashboard/requests/new"
            startIcon={<Icon icon={plusFill} />}
          >
            New Request
          </Button>
        )}

        {!mine && ['ADMIN', 'FINANCE'].includes(user.role) && <AdminExportButton />}
      </Stack>
      <RequestsGrid
        query={
          mine
            ? ({ params }) => getMyRequests({ id: user?.id, params: params })
            : ({ params }) => getAllRequests({ params: params })
        }
        queryId={mine ? ['requests', user?.id] : ['requests']}
        onRowClick={(id) => {
          navigate(`./${id}`);
        }}
      />
    </Page>
  );
}
